// extracted by mini-css-extract-plugin
export default {"hours":"Time_hours__iBYwF","minutes":"Time_minutes__44yp5","seconds":"Time_seconds__W7cFK","milliseconds":"Time_milliseconds__8v8vN"};